var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99996 1.55981L14.3333 5.2853V14.3333H1.66663V5.2853L7.99996 1.55981ZM7.33329 12.9999H8.66663V9.99993H7.33329V12.9999ZM9.99996 12.9999V8.6666H5.99996V12.9999H2.99996V6.0479L7.99996 3.10672L13 6.0479V12.9999H9.99996Z",
    fill: "#4E5969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
export default __webpack_public_path__ + "static/media/component.92563f73398a0f3a8a49572fb398b49e.svg";
export { ForwardRef as ReactComponent };